module.exports = __webpack_public_path__ + "static/img/qysm3.73f9f67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/qysm3.png
// module id = xjPj
// module chunks = 0